import {
  embeddedReboqueToForm,
  mergeDriverVehicleTrailerIds,
  normalizeTrailerIds,
} from "./reboque-trailer-utils";

export function sameTrailerIds(left = [], right = []) {
  const a = normalizeTrailerIds(left);
  const b = normalizeTrailerIds(right);
  return a.length === b.length && a.every((id, index) => id === b[index]);
}

/**
 * A partir da seleção da UI (união), calcula o próximo estado
 * veículo vs legado do motorista. Reboques novos vão para o veículo.
 */
export function splitTrailerSelectionChange({
  nextSelection,
  vehicleTrailerIds,
  driverLegacyTrailerIds,
}) {
  const next = normalizeTrailerIds(nextSelection);
  const vehicle = normalizeTrailerIds(vehicleTrailerIds);
  const legacy = normalizeTrailerIds(driverLegacyTrailerIds);
  const previous = mergeDriverVehicleTrailerIds(vehicle, legacy);
  const vehicleSet = new Set(vehicle);
  const legacySet = new Set(legacy);

  const removed = previous.filter((id) => !next.includes(id));
  const added = next.filter((id) => !previous.includes(id));

  let nextVehicle = [...vehicle];
  let nextLegacy = [...legacy];

  for (const id of removed) {
    if (legacySet.has(id) && !vehicleSet.has(id)) {
      nextLegacy = nextLegacy.filter((item) => item !== id);
    } else if (vehicleSet.has(id)) {
      nextVehicle = nextVehicle.filter((item) => item !== id);
    }
  }

  nextVehicle = normalizeTrailerIds([...nextVehicle, ...added]);
  nextLegacy = normalizeTrailerIds(nextLegacy);

  return {
    nextVehicleTrailerIds: nextVehicle,
    nextDriverLegacyTrailerIds: nextLegacy,
    vehicleChanged: !sameTrailerIds(nextVehicle, vehicle),
  };
}

export function mapEmbeddedReboquesForDisplay(reboques, trailerIds) {
  const ids = normalizeTrailerIds(trailerIds);
  return (Array.isArray(reboques) ? reboques : [])
    .filter((reboque) => {
      const id = String(reboque?.id || "").trim();
      if (id) return !ids.includes(id);
      return Boolean(reboque?.placaReboque);
    })
    .map((reboque) => embeddedReboqueToForm(reboque));
}

export function loadTrailerStateFromVehicleAndPointer(vehicle, pointer) {
  const vehicleTrailerIds = normalizeTrailerIds(vehicle?.trailerIds);
  const driverLegacyTrailerIds = normalizeTrailerIds(pointer?.trailerIds).filter(
    (id) => !vehicleTrailerIds.includes(id),
  );

  return {
    vehicleTrailerIds,
    driverLegacyTrailerIds,
    embeddedReboques: mapEmbeddedReboquesForDisplay(
      vehicle?.reboques,
      vehicleTrailerIds,
    ),
  };
}

/** Ponteiro fino do motorista: vehicleId + legado (sem reboques novos do veículo). */
export function buildDriverVehiclePointer({
  vehicleId,
  veiculoProprio,
  driverLegacyTrailerIds,
}) {
  return {
    vehicleId: vehicleId ? vehicleId : "",
    trailerIds: normalizeTrailerIds(driverLegacyTrailerIds),
    ...(veiculoProprio != null ? { veiculoProprio } : {}),
  };
}
